// jquery ajax tabs module
jQuery.fn.ajaxTabs = function(opt){
	// default options
	var opt = jQuery.extend({
		loadingClass:'ajax-loading',
		activeClass:'active',
		addToParent:false,
		tabLinks:'a.tab',
		tabHolder:'div.ajax-hold',
		minDelay:500,
		animSpeed:0,
		onTabLoad: null,
		event:'click'
	},opt);

	return this.each(function(){
		var holder = jQuery(this);
		var tabLinks = jQuery(opt.tabLinks, holder);
		var tabHolder = jQuery(opt.tabHolder, holder);
		var tabset = (opt.addToParent ? tabLinks.parent() : tabLinks);
		var ajaxBusy, fakeTimer, timerState;
		var hashLink = tabLinks.filter('[data-category="' + window.location.hash.split('#')[1] + '"]');

		// before init callback
		if(typeof opt.onBeforeInit === 'function') {
			opt.onBeforeInit(tabLinks, tabset, opt);
		}

		// tabs init
		if (hashLink.length) {
			tabLinks.each(function(){
				var tmpLink = jQuery(this);
				(opt.addToParent ? tmpLink.parent() : tmpLink).removeClass(opt.activeClass);
			});

			(opt.addToParent ? hashLink.parent() : hashLink).addClass(opt.activeClass);
			switchTab(hashLink);
		} else {
			tabLinks.each(function(){
				var tmpLink = jQuery(this);
				var classItem = (opt.addToParent ? tmpLink.parent() : tmpLink);
				if(classItem.hasClass(opt.activeClass)) switchTab(tmpLink);
			});
		}

		// on init callback
		if(typeof opt.onInit === 'function') {
			opt.onInit(tabLinks, tabset, opt);
		}

		// tab switch function
		function switchTab(lnk) {
			if(!ajaxBusy) {
				var tabSrc = jQuery(lnk).attr('href');
				var loadedTab = tabHolder.children('[rel="'+tabSrc+'"]');
				var activeTab = tabHolder.children('.'+opt.activeClass);
				if(loadedTab.length) {
					if(!loadedTab.hasClass(opt.activeClass)) {
						changeTabs(activeTab,loadedTab,lnk);
					}
				} else {
					// load external content
					if(activeTab.length) {
						tabHolder.css('height', tabHolder.outerHeight());
						activeTab.fadeOut(opt.animSpeed);
					}
					ajaxBusy = true;
					holder.addClass(opt.loadingClass);
					jQuery.ajax({
						url:tabSrc,
						type:'get',
						dataType:'text',
						success:function(msg) {
							loadedTab = jQuery('<div>',{'class':'tab-block',rel:tabSrc,html:msg}).hide().appendTo(tabHolder);
							if(timerState < 0) {
								showLoadedTab();
							}
						},
						error:function() {
							alert('AJAX Error!');
							holder.removeClass(opt.loadingClass);
							tabHolder.css('height', '');
						}
					});

					// min delay before showing tab
					timerState = 0;
					clearTimeout(fakeTimer);
					fakeTimer = setTimeout(function(){
						if(loadedTab && loadedTab.length) {
							timerState = 1;
							showLoadedTab();
						} else {
							timerState = -1;
						}
					},opt.minDelay)
				}
				function showLoadedTab() {
					ajaxBusy = false;
					holder.removeClass(opt.loadingClass);
					tabHolder.css('height', '');
					changeTabs(activeTab,loadedTab,lnk);
					if(typeof opt.onTabLoad === 'function') {
						opt.onTabLoad(loadedTab);
					}
				}

				window.location.hash = jQuery(lnk).data('category');
			}
		}
		function changeTabs(prev, current, tablink) {
			if(prev && prev.length) prev.removeClass(opt.activeClass).fadeOut(opt.animSpeed);
			if(current && current.length) {
				setTimeout(function(){
					current.addClass(opt.activeClass).css({display:'none'}).fadeIn(opt.animSpeed);
					if(typeof opt.onChange === 'function') {
						opt.onChange(jQuery(tablink), current, prev);
					}
				},opt.animSpeed+1);
			}
			tabset.removeClass(opt.activeClass);
			(opt.addToParent ? jQuery(tablink).parent() : jQuery(tablink)).addClass(opt.activeClass);
		}

		// event handlers
		tabLinks.each(function(){
			jQuery(this).bind(opt.event,function(){
				switchTab(this);
				return false;
			});
		});
	});
}
